import { InfoCircle } from 'assets/icons/InfoCircle';
import { DisclaimerCard } from 'components/DisclaimerCard';
import DropdownMenu from 'components/DropdownMenu';
import { PageFilterCard } from 'components/FilterCard';
import { createPortal } from 'react-dom';

// export const floorLayoutList = {
//   'vic-1': {
//     id: 'vic-1',
//     label: 'VIC 1',
//     segments: {
//       'vic-1.1': ['5-22'],
//       'vic-1.2': ['5-22', '23-25'],
//       'vic-1.3': ['5-25', '26-28'],
//     },
//     // segments: [
//     //   { id: 'vic-1.1', floors: ['5-22'] },
//     //   { id: 'vic-1.2', floors: ['5-22', '23-25'] },
//     //   { id: 'vic-1.3', floors: ['5-25', '26-28'] },
//     // ],
//   },
//   'vic-2': {
//     id: 'vic-2',
//     label: 'VIC 2',
//     segments: {
//       'vic-2.1': ['5-22'],
//       'vic-2.2': ['5-22', '23-25'],
//       'vic-2.3': ['5-25', '26-28'],
//     },
//     //
//     // segments: [
//     //   { id: 'vic-2.1', floors: ['5-22'] },
//     //   { id: 'vic-2.2', floors: ['5-22', '23-25'] },
//     //   { id: 'vic-2.3', floors: ['5-25', '26-28'] },
//     // ],
//   },
// };

export const floorLayoutList = {
  'viz-1': {
    id: 'viz-1',
    label: 'VIZ-1',
    segments: {
      'viz-1.1': ['5-45'],
      'viz-1.2': ['5-45'],
      'viz-1.3': ['5-45'],
    },
    // segments: [
    //   { id: 'viz-1.1', floors: ['6-22'] },
    //   { id: 'viz-1.2', floors: ['6-22', '23-25'] },
    //   { id: 'viz-1.3', floors: ['6-22', '26-28'] },
    // ],
  },
  'vic-2': {
    id: 'vic-2',
    label: 'VIC-2',
    segments: {
      'vic-2.1': ['5-45'],
      'vic-2.2': ['5-45'],
      'vic-2.3': ['5-45'],
    },
    //
    // segments: [
    //   { id: 'vic-2.1', floors: ['5-22'] },
    //   { id: 'vic-2.2', floors: ['5-22', '23-25'] },
    //   { id: 'vic-2.3', floors: ['5-25', '26-28'] },
    // ],
  },
};

export const Filter = ({
  onChangeBuilding,
  onChangeSegment,
  onChangeFloor,
  selectedBuilding,
  selectedFloor,
  selectedSegment,
}) => {
  const isDesktop = window.innerWidth > 768;

  const sharedProps = {
    onChangeBuilding,
    onChangeSegment,
    onChangeFloor,
    selectedBuilding,
    selectedFloor,
    selectedSegment,
  };

  return (
    <>
      {createPortal(
        <PageFilterCard className="mat-bang-tang-filter-card">
          <Content {...sharedProps} />
        </PageFilterCard>,
        document.body
      )}
      {!isDesktop && (
        <DropdownMenu className="dropdown-mobile">
          <DropdownMenu.Trigger>
            <InfoCircle />
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align="end" side="bottom" sideOffset={16}>
            <DisclaimerCard />
          </DropdownMenu.Content>
        </DropdownMenu>
      )}
    </>
  );
};

const Content = ({
  onChangeBuilding,
  onChangeSegment,
  onChangeFloor,
  selectedBuilding,
  selectedFloor,
  selectedSegment,
}) => {
  // const currentBuilding = floorLayoutList[selectedBuilding];
  // const segments = currentBuilding?.segments || {};
  // const floors = segments[selectedSegment] || [];

  const handleBuildingClick = (e) => {
    const buildingId = e.currentTarget.getAttribute('data-building');
    onChangeBuilding(buildingId);
  };

  // const handleSegmentClick = (e) => {
  //   const segmentId = e.currentTarget.getAttribute('data-segment');
  //   onChangeSegment(segmentId);
  // };

  // const handleFloorClick = (e) => {
  //   const floorId = e.currentTarget.getAttribute('data-floor');
  //   onChangeFloor(floorId);
  // };

  return (
    <div className="filter-container">
      {/* Building tabs */}
      <div className="filter-tab">
        {Object.values(floorLayoutList).map((building) => (
          <button
            key={building.id}
            data-building={building.id}
            className={`tab-item ${
              building.id === selectedBuilding ? 'active' : ''
            }`}
            onClick={handleBuildingClick}
          >
            {building.label}
          </button>
        ))}
      </div>

      {/* Segment tabs */}
      {/* <div className="sub_filter-tab">
        {Object.keys(segments).map((segmentId) => (
          <button
            key={segmentId}
            data-segment={segmentId}
            className={`tab-item ${
              segmentId === selectedSegment ? 'active' : ''
            }`}
            onClick={handleSegmentClick}
          >
            {segmentId.toUpperCase()}
          </button>
        ))}
      </div> */}

      {/* Floor items */}
      {/* <div className="filter-items">
        {floors.map((floor) => (
          <button
            key={floor}
            data-floor={floor}
            className={`floor-item ${floor === selectedFloor ? 'active' : ''}`}
            onClick={handleFloorClick}
          >
            {floor}
          </button>
        ))}
      </div> */}
    </div>
  );
};
